import { memo, useState, useEffect } from 'react'

import Header from './Header'
import PatientsList from './PatientsList'
import PatientsListSkeleton from './PatientsListSkeleton'

const Content = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <Header />
      {loading ? <PatientsListSkeleton /> : <PatientsList />}
    </>
  )
}

Content.whyDidYouRender = true

export default memo(Content)
